import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, ViewChildren } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MessageService } from 'src/app/@modules/components/message/message.service';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class Utils {

  constructor(
    private http: HttpClient,
    private messageService : MessageService
  ) { }

  getAbbreviatedText(text):string{
    text = text.split("  ").join(" ");
    let val:string = "";
    let split = text.split(" ");
    let formattedSplit = [];
    if(split.length > 1){
      for(let v of split){
        formattedSplit.push(v[0].toUpperCase());
      }
      val = formattedSplit.join("");
    }
    else{
      val = text[0].toUpperCase();
    }
    return val;
  }

//   clearPaginatedSelects(paginated_selects:PaginatedSelectComponent[]) {
//     if(paginated_selects){
//       for(let paginatedSelect of paginated_selects['_results']){
//         let select:PaginatedSelectComponent = paginatedSelect;
//         if(select && select.pg_select){
//           select.pg_select._selectedOption = null;
//           select.pg_select._selectedOptions = new Set();
//           select.pg_select._value = [];
//         }
//         select.form.reset();
//         select.row = null;
//         console.log(select);
//       }
//     }
//   }

//   forceTouchPaginatedSelects(paginated_selects:PaginatedSelectComponent[]) {
//     if(paginated_selects){
//       for(let paginatedSelect of paginated_selects['_results']){
//         let select:PaginatedSelectComponent = paginatedSelect;
//         if(select && select.pg_select){
//           select.form.markAllAsTouched();
//         }
//       }
//     }
//   }
  filterArrayByIds(idList: number[], array: any[]) {
    let filteredArray = array.filter(item => !idList.includes(item.id));
    let mapValues: Map<number, any> = new Map<number, any>();
    for (let val of filteredArray) {
      mapValues.set(val.id, val);
    }
    return Array.from(mapValues.values());
  }

  static isFormTouched(form, controlName, hasPassword?: boolean) {
    if (hasPassword) {
      form.get('password').clearValidators();
      form.get('password_confirmation').clearValidators();
      form.get('password').updateValueAndValidity();
      form.get('password_confirmation').updateValueAndValidity();
    }
    try {
      if (form.get(controlName).touched && form.get(controlName).invalid) {
        return true;
      }
      else {
        return false;
      }
    }
    catch (err) {
//       console.log(controlName);
    }
  }


  filteredParams:any = {};
  filterUpdateTimeout:any;
  pushFiltersToRouter(value,name,filteredParams):EventEmitter<any>{
    let pusher = new EventEmitter<any>();
    let _this = this;
    this.filteredParams = filteredParams;
    value = encodeURIComponent(value);
    let paramStream = "?";
    for(let param in _this.filteredParams){
      if(!_this.filteredParams[param] || _this.filteredParams[param] == "null"){
        continue;
      }
      paramStream += param+"="+_this.filteredParams[param]+"&";
    }
    if(_this.filterUpdateTimeout){
      clearTimeout(_this.filterUpdateTimeout);
      _this.filterUpdateTimeout = null;
    }
    _this.filterUpdateTimeout = setTimeout(() => {
      pusher.emit(paramStream);
      //window.history.pushState(null,"",("transaction"+paramStream));
      clearTimeout(_this.filterUpdateTimeout);
      _this.filterUpdateTimeout = null;
    }, 500);
    return pusher;
  }

  formatNumbersToFixedWithCommas(number){
    var amount=parseFloat(number).toFixed(2);
    var formattedString= amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formattedString;
  }


  submitToggle(activeActionTitle,messageService,searchParams,rows,tableName) {
    let _this = this;
    switch (activeActionTitle) {
      case 'Export Selected':
        messageService.remove();
        messageService.success("Exported Selected Records!", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
        let recordIds: number[] = [];
        console.log(rows);
        for (let row of rows) {
          recordIds.push(row.id);
        }
        let params = { ...searchParams, list_all: false, records: recordIds }
        //this.exportTableDownload(tableName, params);
        break;
      case 'Export All':
        messageService.remove();
       // this.exportTableDownload(tableName, { ...searchParams, list_all: true, records: [] });
        messageService.success("Exported All Records!", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
        break;
      default:
        messageService.error("Please select a bulk action!", { Position: 'bottom-right', Style: 'simple', Duration: 5000 });
        break;
    }
  }

  successMessage(message,duration?){
    this.messageService.success(message, { Position: 'bottom-right', Style: 'simple', Duration: duration ? duration : 5000 });
  }

  errorMessage(message,duration?){
    this.messageService.error(message, { Position: 'bottom-right', Style: 'simple', Duration: duration ? duration : 5000 });
  }

  getCommisionType() {
		return [
			{
				name: 'Both',
				value: 'all'
			},
      {
				name: 'Cruise',
				value: 'cruise'
			}
		]
	}

  validateHoursDifferentToCanCancelTour(date: string, time: string) {
		const now = new Date();
		const bookingDate = new Date(date)

		bookingDate.setHours(parseInt(time.split(':')[0]));
		bookingDate.setMinutes(parseInt(time.split(':')[1]));

		const diffInHours = Math.abs(bookingDate.getTime() - now.getTime()) / (1000 * 60 * 60);

		return diffInHours >= 24;
	}

  generateExcelTransport(filter) {
    this.http.get(`${environment.baseUrl}/report/booking/transportcsv`, {params: filter}).subscribe((data: any ) => {
      FileSaver.saveAs( new Blob([data.data], { type: 'text/csv;charset=utf-8;' }), `transport_bookings_${new Date().getTime()}.csv`);
    }, (err) => {
      console.log('err::: ', err);
    });
  }

  generateExcelBookings(filter) {
    this.http.get(`${environment.baseUrl}/report/booking/exportcsv`, {params: filter}).subscribe((data: any ) => {
      FileSaver.saveAs( new Blob([data.data], { type: 'text/csv;charset=utf-8;' }), `bookings_${new Date().getTime()}.csv`);
    }, (err) => {
      console.log('err::: ', err);
    });
  }

  generateBookingsReportsPDF(filter) {
    this.http.get(`${environment.baseUrl}/report/booking/exportpdf`, { params: filter, responseType: 'blob' })
      .subscribe((data ) => {
        const date = new Date();
        const filename = `report-${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()}-${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}.pdf`;
        FileSaver.saveAs(data, filename);
      }, (err) => {
        console.log('err::: ', err);
      });
  }

  generateBookingsPDF(filter) {
    this.http.get(`${environment.baseUrl}/report/booking/export-booking-pdf`, { params: filter, responseType: 'blob' })
      .subscribe((data ) => {
        const date = new Date();
        const filename = `bookings-${date.getFullYear()}-${
          date.getMonth() + 1
        }-${date.getDate()}-${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}.pdf`;
        FileSaver.saveAs(data, filename);
      }, (err) => {
        console.log('err::: ', err);
      });
  }


  getDataShireburn(filter, withoutCompany = false) {
    let paramsFilter = {
      date: filter['booking_from'],
      company: filter['company'],
    }
    if (withoutCompany) {
      delete paramsFilter['company'];
    }
    this.http.get(`${environment.baseUrl}/report/booking/exportshireburn`, {params: paramsFilter}).subscribe((data: any ) => {
      FileSaver.saveAs( new Blob([data.data], { type: 'text/csv;charset=utf-8;' }), `shireburn_${new Date().getTime()}.csv`);
      }, (err) => {
        console.log('err::: ', err);
      });
  }

}
